// Services
import { BaseCsvRowGenerator } from '~/shared/import/services/csv-row-generator/base';

export class AddressBasedCsvRowGenerator extends BaseCsvRowGenerator {
  protected extractPostcode(address?: string): string | undefined {
    const postcodePattern: RegExp = /\b\d{5}(?:-\d{4})?\b|\b[A-Z0-9]{2,4} ?[A-Z0-9]{2,4}\b/;
    const match: RegExpMatchArray | null | undefined = address?.match(postcodePattern);

    return match ? match[0] : undefined;
  }
}
